import './assets/styles/rulesup.scss';
import { createRoutes } from '@rulesup/routes';
import './store';
import './mixins/rulesupGlobalMixins';
export function installRulesup(namespace) {
  createRoutes(namespace);
}